import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href", "aria-label"]
const _hoisted_2 = { class: "_flexcol _grow-1" }
const _hoisted_3 = { class: "_flexcol _tc--light gfu-bt--overline" }
const _hoisted_4 = {
  class: "_ttu",
  "data-qa": "spotlight-notification-type"
}
const _hoisted_5 = {
  class: "_tc--dark gfu-bt--caption _wbbw",
  "data-qa": "spotlight-notification-project"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_image = _resolveComponent("base-image")
  const _component_notification_delivery_time = _resolveComponent("notification-delivery-time")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass($options.tileClassList)
  }, [
    _createElementVNode("a", {
      href: $props.targetUrl,
      class: "gfu-notification-tile _bgc--white gfu-link--nofx _grow-1",
      "aria-label": $props.displayTitle + ' ' + $props.displayText
    }, [
      _createVNode(_component_base_image, {
        width: "60",
        height: "60",
        src: $options.imageUrl,
        alt: $props.displayTitle,
        loading: "lazy",
        class: "_rounded--common"
      }, null, 8 /* PROPS */, ["src", "alt"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_notification_delivery_time, {
            timestamp: $props.createdAt,
            class: "_shrink-0",
            "data-qa": "spotlight-notification-created-at"
          }, null, 8 /* PROPS */, ["timestamp"]),
          _createElementVNode("span", _hoisted_4, _toDisplayString($props.displayTitle), 1 /* TEXT */)
        ]),
        _createElementVNode("span", _hoisted_5, _toDisplayString($props.displayText), 1 /* TEXT */)
      ])
    ], 8 /* PROPS */, _hoisted_1)
  ], 2 /* CLASS */))
}